import { KnockGuideProvider } from "@knocklabs/react";
import { type ComponentProps, type ReactNode } from "react";

import { useRefetchKnockGuidesOnResume } from "../hooks/useRefetchKnockGuidesOnResume";

export type KnockGuideProviderWithRefetchProps = ComponentProps<typeof KnockGuideProvider>;

export function KnockGuideProviderWithRefetch(props: KnockGuideProviderWithRefetchProps) {
  const { children, ...knockGuideProps } = props;

  return (
    <KnockGuideProvider {...knockGuideProps}>
      <AutoRefetchGuides>{children}</AutoRefetchGuides>
    </KnockGuideProvider>
  );
}

/**
 * Internal component that calls the refetch hooks. Must be rendered inside KnockGuideProvider to
 * access guide context.
 */
function AutoRefetchGuides(props: { children: ReactNode }) {
  const { children } = props;

  useRefetchKnockGuidesOnResume();

  return children;
}
